import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService, ButtonLoader } from '../../../../../core';
import { ClienteAnaliseFinanceira } from '../cliente-analise-financeira';
import { ClienteAnaliseFinanceiraHttpService, ClienteAnaliseFinanceiraConcluirHttpService } from '../services';
import { ClienteAnaliseFinanceiraFormComponent } from '../form';
import { ClienteNomePipe } from '../../pipes';

@Component({
    selector: 'sgt-cliente-analise-financeira-concluir-modal',
    templateUrl: './cliente-analise-financeira-concluir-modal.component.html',
    styleUrls: ['./cliente-analise-financeira-concluir-modal.component.less'],
    providers: [
        ClienteNomePipe
    ]
})
export class ClienteAnaliseFinanceiraConcluirModalComponent implements OnInit {
    idCliente: number;
    cliente: ClienteAnaliseFinanceira;
    elModal: any;
    isLoading: boolean;

    @ViewChild('form') form: ClienteAnaliseFinanceiraFormComponent;
    @ViewChild('btnConcluir') btnConcluir: ElementRef;

    @Output() afterConcluir = new EventEmitter<ClienteAnaliseFinanceira>();

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private clienteNomePipe: ClienteNomePipe,
                private clienteAnaliseFinanceiraHttpService: ClienteAnaliseFinanceiraHttpService,
                private clienteAnaliseFinanceiraConcluirHttpService: ClienteAnaliseFinanceiraConcluirHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.load()
                    .then(() => {
                        setTimeout(() => this.form?.setFocusAnotacao(), 200);
                    })
                    .catch(() => {});

                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.clear();
                e.stopPropagation();
            });
    }

    /** Carrega a análise financeira do cliente */
    private load(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.cliente = null;
            this.isLoading = true;
            this.clienteAnaliseFinanceiraHttpService.load(this.idCliente)
                .pipe(
                    take(1)
                )
                .subscribe(
                    cliente => {
                        this.cliente = cliente;
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, error.cause, error);
                        this.close();
                        reject();
                    },
                    () => this.isLoading = false
                );
        });
    }

    private clear() {
        this.idCliente = null;
        this.cliente = null;
    }

    open(idCliente: number) {
        this.idCliente = idCliente;
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Conclui a análise financeira do cliente */
    concluir() {
        if (!this.form.isValid()) {
            return;
        }

        const btn = new ButtonLoader(this.btnConcluir.nativeElement);
        btn.loading('Concluíndo');
        this.clienteAnaliseFinanceiraConcluirHttpService.concluir(this.cliente)
            .pipe(
                take(1)
            )
            .subscribe(
                cliente => {
                    this.afterConcluir.emit(cliente);
                    this.messageService.success('', `Conclusão da Análise Financeira do cliente ${this.clienteNomePipe.transform(cliente?.nome, cliente?.nomeFantasia, cliente?.codigoIntegracaoErp)} realizada com sucesso`);
                    this.close();
                },
                (error: ApiError) => this.messageService.error(error.message, error.cause, error),
                () => btn.reset()
            );
    }
}
